import { render } from "./rightbar.html?vue&type=template&id=08207870&external"
import script from "./rightbar.vue?vue&type=script&lang=js"
export * from "./rightbar.vue?vue&type=script&lang=js"

import "./rightbar.vue?vue&type=style&index=0&id=08207870&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__